import request from "@/util/http";
/**
 * 首页
 */
export function index(storeId) {
	return request({
		url: '/store/shop/store/index?id=' + storeId,
		method: 'get',
	})
}


/**
 * 公开店铺列表（默认推荐）
 */
export function list(params) {
	return request({
		url: '/store/biz/store/list',
		method: 'get',
		params: params,
	})
}


/**
 * 搜索
 */
export function search(query) {
	return request({
		url: '/store/shop/store/search',
		method: 'get',
		params: query,
	})
}


/**
 * 搜索
 */
export function search_json(query) {
	return request({
		url: '/store/shop/store/search_json',
		method: 'get',
		params: query,
	})
}

// module.exports = {
// 	index,
// 	search,
// 	search_json,
// }
